import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

export const WaterIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon sx={{fill: "none", strokeWidth: "1.6", ...props.sx}} viewBox="0 0 12 14">
        <path
            d="M5.99687 1L9.53437 4.51576C10.234 5.2106 10.7105 6.09603 10.9037 7.06007C11.0969 8.0241 10.9981 9.02342 10.6197 9.93163C10.2414 10.8398 9.60051 11.6161 8.77819 12.1623C7.95587 12.7085 6.98905 13 6 13C5.01095 13 4.04413 12.7085 3.22181 12.1623C2.39949 11.6161 1.75863 10.8398 1.38029 9.93163C1.00195 9.02342 0.903124 8.0241 1.09632 7.06007C1.28951 6.09603 1.76604 5.2106 2.46563 4.51576L5.99687 1Z"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);
